import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {MessageFormController} from './MessageForm.controller';
import {requireImage} from '../../../../../utils/utils';
import './MessageForm.scss';

interface MessageFormProps {
    controller: MessageFormController;
    isDisabled: boolean;
    placeholder: string;
    dir: 'ltr' | 'rtl';
    onFocus?: () => void;
    onBlur?: () => void;
}

@observer
export class MessageForm extends TechseeBaseComponent<MessageFormProps> {
    private handleSubmit = (e: React.FormEvent): void => {
        e.preventDefault();
        this.props.controller.handleSubmit();
    };

    private handleKeyUp = (e: React.KeyboardEvent): void => {
        this.props.controller.handleKeyPress({
            shiftKey: e.shiftKey,
            ctrlKey: e.ctrlKey,
            keyCode: e.keyCode
        });
    };

    private handleTextareaChange = (e: React.ChangeEvent<HTMLTextAreaElement>): void => {
        this.props.controller.setTextMessage(e.target.value);
    };

    renderInternal(): JSX.Element {
        const {controller, isDisabled, placeholder, dir, onFocus, onBlur} = this.props;

        return (
            <form className='message-send-form' onSubmit={this.handleSubmit}>
                <textarea
                    disabled={isDisabled}
                    onKeyUp={this.handleKeyUp}
                    className='message-form-text'
                    rows={1}
                    placeholder={placeholder}
                    value={controller.textMessage}
                    onChange={this.handleTextareaChange}
                    onFocus={onFocus}
                    onBlur={onBlur}
                />
                <button
                    disabled={isDisabled || !controller.hasText}
                    className={`btn message-form-btn ${!controller.hasText ? 'disabled' : ''}`}
                    type='submit'>
                    <img
                        className={`message-form-btn-icon ${dir === 'rtl' ? 'mirror-image' : ''}`}
                        src={requireImage('sharp-arrow-right.png')}
                        alt='Send Message'
                    />
                </button>
            </form>
        );
    }
}
